import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Drawer, DrawerContent } from '../../common/drawer';
import { RejectNoteType } from '../../types';
import { Content } from '../components';
import { RejectNote } from './reject-note';

const RejectNotesWrapeer = styled.div`
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  align-items: center;
  margin: var(--spacing-04) 0;
`;

const DrawerContentContentWrapper = styled(DrawerContent.Content)`
  background-color: var(--coolest-gray-10);
`;

const DrawerContentTitleWrapper = styled(DrawerContent.Title)`
  border-bottom: 1px solid var(--coolest-gray-20);
`;

export const RejectCommentDrawer: FC<{
  visible: boolean;
  onClose: () => void;
  rejectNotes?: RejectNoteType[];
}> = ({ visible, onClose, rejectNotes }) => {
  const handleClose = () => {
    onClose();
  };

  return (
    <Drawer visible={visible} onClose={handleClose} destroyOnClose>
      <Content>
        <DrawerContentTitleWrapper>
          <FormattedMessage id="comments" />
        </DrawerContentTitleWrapper>
        <DrawerContentContentWrapper>
          <RejectNotesWrapeer>
            {rejectNotes && rejectNotes.length > 0
              ? rejectNotes.map((note) => {
                  return <RejectNote note={note} />;
                })
              : null}
          </RejectNotesWrapeer>
        </DrawerContentContentWrapper>
      </Content>
    </Drawer>
  );
};
